// Filename: models/questionnaire/questionnaire.js
define('models/questionnaire/response',[
    'underscore',
    'backbone',
    'moment',
    // src
    'utils',
    'services/api',
    'services/user',
    // models
    'collections/questionnaire/answers',
    'collections/questionnaire/questions',
    'models/member/profile'
], function(
    _, Backbone, moment, U, API,
    User,
    // models
    CAnswers,
    CQuestions,
    MProfile
) {

    var MResponse = Backbone.Model.extend({
        idAttribute: 'id',
        blacklist: ['_questions', '_answers'],

        urlRoot: function() {
            var url = "questionnaires/r/";

            if (this.isNew()) {
                url = "questionnaires/q/" + this.questionnaire.id + "/";
            }

            return API.url(url);
        },

        url: function() {
            return this.group && this.group.isSupervisor() ?
                MResponse.__super__.url.apply(this, arguments) + '?supervisor' :
                MResponse.__super__.url.apply(this, arguments);
        },

        parse: function(resp, options) {
            if (resp.answers) {
                this.setComputedAnswers(resp);
            }
            return MResponse.__super__.parse.call(this, resp, options);
        },

        getUser: function() {
            return this.get('user');
        },

        getComputedUser: function() {
            var computedUsers = this.get('_user');
            return computedUsers ? new MProfile(this.get('_user')) : null;
        },

        getAnswers: function() {
            return this.get('_answers') || new CAnswers();
        },

        getQuestions: function() {
            return this.get('_questions');
        },

        getTimeStampObject: function() {
            return moment(this.get('dateCompleted'), 'YYYY-MM-DDTHH:mm:ssZ');
        },

        getQuestionnaire: function() {
            return this.get('questionnaire');
        },

        setGroup: function(groupModel) {
            this.group = groupModel;
        },

        setQuestionnaire: function(questionnaireModel) {
            this.questionnaire = questionnaireModel;
        },

        setComputedAnswers: function(resp) {
            var _answers = [];
            _.each(resp.answers, function(value, key) {
                var question = this.questionnaire.getQuestionById(key);
                _answers.push({
                    questionId: parseInt(key),
                    question: question ? question.getName() : "",
                    answer: value,
                    comment: resp.supervisorComments[key]
                });
            }, this);

            resp._answers = new CAnswers(_answers);
        },

        setComments: function() {
            var comments = {};
            this.getAnswersCollection().each(function(answer) {
                comments[answer.id] = answer.get('comment');
            });

            this.set('supervisorComments', comments);
        },

        setAnswers: function() {
            var answers = {},
                defaultAnswer;

            this.getQuestions().each(function(question) {
                defaultAnswer = question.get('type') === 'checkbox' ? [] : "";
                answers[question.id] = question.get('answer') || defaultAnswer;
            });

            return this.set('answers', answers);
        },

        setQuestions: function(questions) {
            // this.getAnswers().reset();

            questions.each(function(question) {
                var answer = this.getAnswersCollection(questions).get(question.id),
                    defaultAnswer = question.getDefaultAnswer();
                question.set('answer', answer ? answer.get('answer') : defaultAnswer);
            }, this);

            return this.set('_questions', questions);
        },

        getAnswersCollection: function(questions) {
            if (!this.getAnswers()) this.createAnswersCollection(questions);
            return this.getAnswers();
        },

        addQuestionToAnswers: function(questions) {
            var answers = this.getAnswers(),
                currentQuestion;

            answers.each(function(answer) {
                currentQuestion = questions.findWhere({ id: answer.get('questionId') });
                answer.set('question', currentQuestion.get('name'));
            }, this);
        },

        createAnswersCollection: function(questions) {
            this.addQuestionToAnswers(questions);
        },

    });

    // Return the model for the module
    return MResponse;
});

